export default __webpack_public_path__ + "static/store-galaxy.en-cb645594f51cac9e2de6333477ab7f5c.png";